import { ProductPage, ProductsPage } from "@/pages";
import { Navigate, Route, Routes } from "react-router-dom";

export const AppRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="*" element={<Navigate to="/products" />} />
        <Route path="/product/:id/:start?" element={<ProductPage />} />
        <Route path="/products/:start?" element={<ProductsPage />} />
      </Routes>
    </div>
  );
};
